import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
import BlogImg from "../assets/img/serviceBg.png";
import MinimalLoader from "./Loader";

const PostDetailsComponent = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState({ name: "", email: "", content: "" });
  const [loading, setLoading] = useState(true);

  // Fetch Post and Comments
  useEffect(() => {
    fetch(`https://blog.365globalconsulting.com/wp-json/wp/v2/posts/${id}?_embed`)
      .then((response) => response.json())
      .then((data) => {
        setPost(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching post:", error);
        setLoading(false);
      });

    fetch(`https://blog.365globalconsulting.com/wp-json/wp/v2/comments?post=${id}`)
      .then((response) => response.json())
      .then((data) => setComments(data))
      .catch((error) => console.error("Error fetching comments:", error));
  }, [id]);

  // Handle New Comment Submission
  const handleSubmitComment = (e) => {
    e.preventDefault();

    fetch("https://blog.365globalconsulting.com/wp-json/wp/v2/comments", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        post: id,
        author_name: newComment.name,
        author_email: newComment.email,
        content: newComment.content,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setComments([...comments, data]);
        setNewComment({ name: "", email: "", content: "" });
      })
      .catch((error) => console.error("Error submitting comment:", error));
  };

  if (loading) {
    return (
      <div className="z-40">
        <MinimalLoader />
      </div>
    );
  }


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  };

  if (!post) {
    return <div>Post not found.</div>;
  }

  return (
    <div>
      {/* <Navbar /> */}
      <div className="block bg-white h-[130px]"></div>
      <div className="md:mt-12">
        <img
          src={
            post._embedded &&
            post._embedded["wp:featuredmedia"] &&
            post._embedded["wp:featuredmedia"][0].source_url
              ? post._embedded["wp:featuredmedia"][0].source_url
              : BlogImg
          }
          alt={post.title.rendered}
          className="w-full md:max-w-[1200px] md:h-[600px] shadow-2xl rounded-xl container mx-auto object-cover "
        />
      </div>
      {/* <div className="mt-4 container mx-auto max-w-5xl px-4">
        <a href="/" className="text-blue-900">Home</a> / <a href="/blog" className=" text-blue-900">Blog</a> / <span className="opacity-60">In The News</span>
      </div> */}
      <div className="container mx-auto mt-6 md:mt-24 max-w-6xl px-4">
        <h2 className="text-primary capitalize text-2xl md:text-5xl md:w- md:mt-20 leading-normal">
          {post.title.rendered}
        </h2>

        <div className="flex items-center gap-4 mb-16 text-gray-600 mt-6">
        <div className="flex items-center gap-2">
          {/* <span className="w-6 h-6">📅</span> */}
          <span>{formatDate(post?.date)}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-6 h-6">👤</span>
          <span>Admin</span>
        </div>
      </div>

      <div className="prose max-w-none">
        <div className="text-lg text-primary mb-8 leading-relaxed">
          <div 
            dangerouslySetInnerHTML={{ __html: post?.content?.rendered }} 
            className="space-y-6"
          />
        </div>
        </div>
      <hr className="mt-12"/>
      
      </div>

      {/* Comments Section */}
      <div className="container mx-auto mt-12 max-w-6xl px-4">
        {comments.length === 0 ? (
            <p>No comments yet. Be the first to comment!</p>
        ) : (
            comments.map((comment) => (
                <div key={comment.id} className="border-b border-gray-200 py-4">
                <h3 className="text-xl font-bold mb-6">Comments</h3>
              <h4 className="font-bold">{comment.author_name}</h4>
              <p>{comment.content.rendered}</p>
            </div>
          ))
        )}

        {/* Add Comment Form */}
        <form onSubmit={handleSubmitComment} className="mt-8">
          <h4 className="text-3xl font-semibold text-primary">Leave a comment</h4>
          <div className="mt-4">
            <label className="block font-semibold">Name</label>
            <input
              type="text"
              value={newComment.name}
              onChange={(e) => setNewComment({ ...newComment, name: e.target.value })}
              className="w-full md:w-1/2 p-2 border border-neutral-400 outline-none rounded-lg"
              placeholder="Enter name"
              required
            />
          </div>
          <div className="mt-4">
            <label className="block font-semibold">Email</label>
            <input
              type="email"
              value={newComment.email}
              onChange={(e) => setNewComment({ ...newComment, email: e.target.value })}
              className="w-full md:w-1/2 p-2 border border-neutral-400 outline-none rounded-lg"
              placeholder="Enter email"
              required
            />
          </div>
          <div className="mt-4">
            <label className="block font-semibold">Comment</label>
            <textarea
              value={newComment.content}
              onChange={(e) => setNewComment({ ...newComment, content: e.target.value })}
              className="w-full md:w-1/2 p-2 border border-neutral-400 outline-none rounded-lg"
              rows="6"
              required
              placeholder="Your comment"
            ></textarea>
          </div>
          <button type="submit" className="mt-4 uppercase bg-secondary rounded-full text-white px-6 py-3 hover:bg-gray-cool duration-300">
            Submit Comment
          </button>
        </form>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default PostDetailsComponent;
